<template>
    <div aria-hidden="true" id="circle-slider" class="field--default--field-circle-slider--home-page circle-slider">
        <svg v-if="hasStepsContent"  class=main-circle xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
             y="0px" viewBox="0 0 587 587" xml:space="preserve">
          <defs>
              <linearGradient x1="-1.11022302e-14%" y1="50%" x2="88.5718149%" y2="50%" id="linearGradient-1">
                  <stop stop-color="#3CF000" offset="0%"></stop>
                  <stop stop-color="#00C8BE" stop-opacity="0" offset="100%"></stop>
              </linearGradient>
          </defs>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Homepage---Desktop" transform="translate(-1211.000000, -206.000000)"
                 stroke="url(#linearGradient-1)" stroke-width="2">
                  <g id="Group-6" transform="translate(1170.000000, 207.000000)">
                      <circle id="Oval" cx="334.5" cy="292.5" r="292.5"></circle>
                  </g>
              </g>
          </g>
        </svg>

        <div class="rotating-circles" :style="wheelRotation" ref="wheel">
            <template v-if="hasStepsContent">
                <div class="circle" :style="circleStyle(2)"
                     :class="[`circle-${0}`, { active: activeCircleClass(0), 'sub-active': subActiveCircleClass(0), 'circle-hidden': hiddenCircleClass(0) }]">
                    <div class="inner-circle">
                        <template v-if="displayMode === 'garage'">
                            <div class="amount">
                                {{ this.stepsContent[0].amount }}
                            </div>

                            <div>
                                {{ clientsTxt }}
                            </div>
                        </template>

                        <template v-if="displayMode === 'customer'">
                            <div class="year">
                                {{ this.stepsContent[0].year }}
                            </div>

                            <div class="amount">
                                {{ this.stepsContent[0].amount }}
                            </div>
                        </template>
                    </div>
                </div>
                <div class="circle" :style="circleStyle(1)"
                     :class="[`circle-${1}`, { active: activeCircleClass(1), 'sub-active': subActiveCircleClass(1), 'circle-hidden': hiddenCircleClass(1) }]">
                    <div class="inner-circle">
                        <template v-if="displayMode === 'garage'">
                            <div class="amount">
                                {{ this.stepsContent[1].amount }}
                            </div>

                            <div>
                                {{ clientsTxt }}
                            </div>
                        </template>

                        <template v-if="displayMode === 'customer'">
                            <div class="year">
                                {{ this.stepsContent[1].year }}
                            </div>

                            <div class="amount">
                                {{ this.stepsContent[1].amount }}
                            </div>
                        </template>
                    </div>
                </div>

                <div class="circle" :style="circleStyle(0)"
                     :class="[`circle-${2}`, { active: activeCircleClass(2), 'sub-active': subActiveCircleClass(2), 'circle-hidden': hiddenCircleClass(2) }]">
                    <div class="inner-circle">
                        <template v-if="displayMode === 'garage'">
                            <div class="amount">
                                {{ this.stepsContent[2].amount }}
                            </div>

                            <div>
                                {{ clientsTxt }}
                            </div>
                        </template>

                        <template v-if="displayMode === 'customer'">
                            <div class="year">
                                {{ this.stepsContent[2].year }}
                            </div>

                            <div class="amount">
                                {{ this.stepsContent[2].amount }}
                            </div>
                        </template>
                    </div>
                </div>

                <div class="circle" :style="circleStyle(4)"
                     :class="[`circle-${3}`, { active: activeCircleClass(3), 'sub-active': subActiveCircleClass(3), 'circle-hidden': hiddenCircleClass(3) }]">
                    <div class="inner-circle">
                        <template v-if="displayMode === 'garage'">
                            <div class="amount">
                                {{ this.stepsContent[3].amount }}
                            </div>

                            <div>
                                {{ clientsTxt }}
                            </div>
                        </template>

                        <template v-if="displayMode === 'customer'">
                            <div class="year">
                                {{ this.stepsContent[3].year }}
                            </div>

                            <div class="amount">
                                {{ this.stepsContent[3].amount }}
                            </div>
                        </template>
                    </div>
                </div>
                <div class="circle" :style="circleStyle(3)"
                     :class="[`circle-${4}`, { active: activeCircleClass(4), 'sub-active': subActiveCircleClass(4), 'circle-hidden': hiddenCircleClass(4) }]">
                    <div class="inner-circle">
                        <template v-if="displayMode === 'garage'">
                            <div class="amount">
                                {{ this.stepsContent[4].amount }}
                            </div>

                            <div>
                                {{ clientsTxt }}
                            </div>
                        </template>

                        <template v-if="displayMode === 'customer'">
                            <div class="year">
                                {{ this.stepsContent[4].year }}
                            </div>

                            <div class="amount">
                                {{ this.stepsContent[4].amount }}
                            </div>
                        </template>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>


<script>

export default {
    name: "CircleSlider",

    props: {
        restExportUrl: {
            type: String,
            required: true
        },
        displayMode: {
            type: String,
            required: false,
            default: 'garage'
        }
    },

    data() {
        return {
            currentStep: 1,
            stepsContent: null,
            stepInterval: null,
            width: window.innerWidth,
            circleObserver: null,
            clientsTxt: window.Drupal.t('Customers'),
        }
    },

    computed: {
        wheelRotation() {
            return `transform: rotate(calc(${this.currentStep * 72}deg - 30deg))`;
        },

        hasStepsContent() {
            return !_.isEmpty(this.stepsContent);
        }
    },

    mounted() {
        this.fetchData();

        window.onfocus = () => {
            if (!(this.currentStep >= 5)) {
                this.startSlider();
            }
        }

        window.onblur = () => this.stopSlider();
    },

    methods: {
        startSlider() {
            this.stepInterval = setInterval(() => this.currentStep++, 3100);
        },

        stopSlider() {
            clearInterval(this.stepInterval);
        },

        fetchData() {
            axios.get(`/${window.drupalSettings.ef2_custom.lang_code + this.restExportUrl}`)
                .then(({data}) => {
                    this.stepsContent = data;
                    this.startSlider();
                })
                .catch(error => console.log(error));
        },

        activeCircleClass(circle) {
            return (this.currentStep - 1) === circle;
        },

        subActiveCircleClass(circle) {
            if (this.currentStep === 1 && circle === 1) {
                return true;
            }

            if (this.currentStep === 2 && circle === 2) {
                return true;
            }

            if (this.currentStep === 3 && circle === 3) {
                return true;
            }

            if (this.currentStep === 4 && circle === 4) {
                return true;
            }

            if (this.currentStep === 5 && circle === 0) {
                return true;
            }

            return false;
        },

        hiddenCircleClass(circle) {
            if (this.currentStep === 1 && circle === 3) {
                return true;
            }

            if (this.currentStep === 2 && circle === 4) {
                return true;
            }

            if (this.currentStep === 3 && circle === 0) {
                return true;
            }

            if (this.currentStep === 4 && circle === 1) {
                return true;
            }

            if (this.currentStep === 5 && circle === 2) {
                return true;
            }

            return false;
        },

        circleStyle(circle) {
            let angle = (360 / 5);
            let rot = (circle * angle);
            let circleSize = this.width > 768 ? 500 : 300;

            return `transform: rotate(calc(${rot} * 1deg)) translate(calc(${circleSize}px / 2)) rotate(calc(${(rot + (angle * this.currentStep))} * -1deg + 30deg))`;
        },
    },

    watch: {
        currentStep(value) {
            window.eventBus.$emit('circle-slider-step', value);

            if (value === 5) {
                this.stopSlider();
                this.stepInterval = null;
            }
        }
    }
}
</script>
